<script lang="ts">
  import { _ } from "svelte-i18n";
  import { createEventDispatcher, onMount } from "svelte";
  import Typography from "$lib/components/Typography/Typography.svelte";
  import Denomination from "./Denomination.svelte";

  export let margin = "";
  export let selectedDenominationOption: {
    value?: string;
    inStock?: boolean;
    displayName?: string;
  } = {};
  export let denominationOptions: { value: string; inStock?: boolean }[];
  export let small = false;

  export let altSelect = undefined;

  const dispatch = createEventDispatcher();

  const selectSize = (event: CustomEvent) => {
    if (altSelect) {
      altSelect(event);
    } else {
      selectedDenominationOption = event.detail;
      dispatch("select", selectedDenominationOption);
    }
  };

  let displayDenomination = "";
  let denominationOptionsDisplay: {
    value: string;
    inStock?: boolean;
    displayName: string;
  }[] = [];

  $: {
    denominationOptionsDisplay =
      denominationOptions &&
      denominationOptions.map(denominationOption => {
        displayDenomination = denominationOption.value;
        return {
          value: denominationOption.value,
          inStock: denominationOption.inStock,
          displayName: displayDenomination,
        };
      });

    denominationOptionsDisplay &&
      denominationOptionsDisplay.sort(
        (a, b) => parseFloat(a.displayName) - parseFloat(b.displayName),
      );
  }

  let viewportWidth: number;
  let isMobile = false;
  let lgWidth = 1280;

  onMount(() => {
    const bodyStyle = getComputedStyle(document.body);
    lgWidth = Number(bodyStyle.getPropertyValue("--lg").replace(/\D/g, ""));
  });

  $: viewportWidth >= lgWidth ? (isMobile = false) : (isMobile = true);
</script>

<style lang="scss">
  .size-swatch {
    @include breakpoint(lg) {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    &--hover-message {
      padding-bottom: 8px;
    }
    &--sizes-container {
      overflow: hidden;
      position: relative;
    }
    &--sizes-wrapper {
      line-height: 0;
      display: flex;
      flex-wrap: wrap;
      gap: 0.5rem;
    }
  }
  .size-guide-link {
    margin: 12px 0 0;
    width: fit-content;
    align-self: flex-start;
    @include breakpoint(lg) {
      margin: 6px 0 0;
    }
  }
  .inline-anchor:hover {
    color: $on-surface-30;
    cursor: pointer;
  }
</style>

<svelte:window bind:innerWidth={viewportWidth} />

{#if denominationOptions}
  <div class="size-swatch">
    <div class="size-swatch--sizes-container">
      {#if small}
        <div class="size-swatch--hover-message">
          <Typography component="span" variant="body1" theme="on-surface-30"
            >{$_("Denominations available")}:</Typography
          >
        </div>
      {/if}

      <div class="size-swatch--sizes-wrapper">
        {#each denominationOptionsDisplay as denominationOption}
          <Denomination
            {margin}
            {small}
            {denominationOption}
            selected={selectedDenominationOption.value ===
              denominationOption.value}
            on:select={e => {
              selectSize(e);
            }}
            preventDefault={altSelect !== undefined ? true : false}
          />
        {/each}
      </div>
    </div>
  </div>
{/if}
